import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import Eyebrow from "@/components/site/Eyebrow";
import { ACCENT, NAVY, CREAM } from "@/lib/siteTheme";
import heronIcon from "@/assets/design/blue-heron-icon.webp";
import googleBadge from "@/assets/design/google-icon.webp";
import { reviews } from "@/lib/reviews";

const Reviews = () => {
  return (
    <Layout active="reviews" background={NAVY}>
      <div style={{ fontFamily: "'Archivo', sans-serif", background: NAVY }} className="bh-reviews w-full antialiased">
        <Seo
          title="Reviews | Blue Heron Marketing"
          description="Real, unedited reviews from Blue Heron Marketing clients. Rated 5.0 on Google."
          path="/reviews"
        />

        {/* Hero */}
        <section className="relative overflow-hidden px-6 md:px-14 pt-[120px] pb-[88px] text-center" style={{ background: NAVY }}>
          <div className="absolute -right-[140px] -bottom-10 pointer-events-none" style={{ width: 560, maxWidth: "55vw", opacity: 0.06, transform: "scaleX(-1)" }}>
            <img src={heronIcon} alt="" width={500} height={366} className="w-full h-auto block brightness-0 invert" style={{ animation: "bhFloat 11s ease-in-out infinite" }} />
          </div>
          <div className="max-w-[1280px] mx-auto relative z-10">
            <div className="flex flex-col items-center mb-6">
              <Eyebrow dark className="items-center">Proof, Not Promises</Eyebrow>
            </div>
            <h1 className="font-black leading-[0.98] tracking-[-0.02em] mb-6" style={{ color: CREAM, fontSize: "clamp(40px,6vw,76px)" }}>
              What clients actually say.
            </h1>
            <p className="max-w-[560px] mx-auto leading-relaxed" style={{ color: "rgba(247,243,236,0.78)", fontSize: "clamp(17px,1.6vw,20px)" }}>
              Real reviews, unedited. Blue Heron is rated 5.0 on Google.
            </p>
          </div>
        </section>

        {/* Reviews grid */}
        <section className="px-6 md:px-14 pb-[140px]" style={{ background: CREAM }}>
          <div className="max-w-[1280px] mx-auto relative z-[2]" style={{ marginTop: -56 }}>
            <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
              {reviews.map((r) => (
                <div
                  key={r.name}
                  className="break-inside-avoid bg-white rounded-2xl px-[26px] pt-[26px] pb-7 mb-6"
                  style={{ border: "1px solid rgba(14,16,21,.07)", boxShadow: "0 12px 30px rgba(14,38,68,.06)" }}
                >
                  <div className="flex items-center justify-between mb-3.5">
                    <div className="flex items-center gap-2.5">
                      <img src={googleBadge} alt="" width={94} height={96} className="w-[22px] h-[22px] block" />
                      <span className="font-extrabold text-[15px]" style={{ color: NAVY }}>{r.name}</span>
                    </div>
                    <span style={{ color: ACCENT, fontSize: 13, letterSpacing: "1px" }}>★★★★★</span>
                  </div>
                  <p className="text-[14.5px] leading-relaxed" style={{ color: "rgba(14,16,21,0.7)" }}>{r.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="px-6 md:px-14 pt-[20px] pb-24 text-center" style={{ background: CREAM }}>
          <div className="max-w-[760px] mx-auto">
            <h2 className="font-black leading-[0.98] tracking-[-0.025em] mb-5" style={{ color: NAVY, fontSize: "clamp(30px,4.4vw,52px)" }}>
              Ready to be our next review?
            </h2>
            <p className="mb-8 text-lg leading-relaxed" style={{ color: "rgba(17,33,47,0.65)" }}>
              Let's talk about what's actually possible for your business.
            </p>
            <Link
              to="/book"
              className="inline-flex items-center gap-2.5 font-extrabold text-lg px-[38px] py-5 rounded-full no-underline transition-transform hover:-translate-y-1"
              style={{ background: ACCENT, color: NAVY, boxShadow: "0 16px 32px rgba(14,40,70,.16)" }}
            >
              Book A Free Call →
            </Link>
          </div>
        </section>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .bh-reviews h1, .bh-reviews h2, .bh-reviews h3, .bh-reviews h4 {
          font-family: 'Archivo', sans-serif;
        }
        @keyframes bhFloat {
          0% { transform: translateY(0) rotate(-6deg); }
          50% { transform: translateY(-22px) rotate(-4deg); }
          100% { transform: translateY(0) rotate(-6deg); }
        }
      ` }} />
    </Layout>
  );
};

export default Reviews;
